import { Injectable } from '@angular/core';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {Http} from '@angular/http';
import {constant} from '../../app.constants';
import {Router} from '@angular/router';
declare var jQuery: any;
@Injectable()
export class SignalRService extends ParentService {

  private handlers = new Map<string, (...args: any[]) => void>();

  public connection: any;
  private proxy: any;
  constructor(
    protected http: Http,
    private route: Router
  ) {
    super();
    this.connection = jQuery.hubConnection(constant.SERVER_WITH_SIGNALR);
    this.proxy = this.connection.createHubProxy('trip2Driver');
  }

  start() {
    return new Promise((resolve: (hubConnection) => void, reject) => {
      if (this.connection.state === jQuery.signalR.connectionState.disconnected) {
        this.connection.start()
          .done(() => {
            resolve(this.connection);
          })
          .fail(() => {
            reject();
          });
      } else {
        resolve(this.connection);
      }
    });
  }


  registerHubConnection(hub, remainingUrl?) {
    return  this.http.post((`${hub}${this.connection.id}` + (remainingUrl ? `/${remainingUrl}` : '')), null, this.headerPost())
      .map(res => {
        res.json();
      })
      .catch(error => this.validate401Error(error, this.route));
  }

  deleteHubConnection(hub, remainingUrl?) {
    return  this.http.delete((`${hub}${this.connection.id}` + (remainingUrl ? `/${remainingUrl}` : '')), this.headerPost())
      .map(res => {
        res.json();
      })
      .catch(error => this.validate401Error(error, this.route));
  }

  subscribeTo(method: string, callback: (...args: any[]) => void): void {
    const existingHandler = this.handlers.get(method);

    if (existingHandler) {
      this.proxy.off(method, existingHandler);
    }
    const handler = (...args: any[]) => {
      callback(...args);
    };
    this.handlers.set(method, handler);
    this.proxy.on(method, handler);
  }

  unsubscribeTo(method: string): void {
    const existingHandler = this.handlers.get(method);
    if (existingHandler) {
      this.proxy.off(method, existingHandler);
      this.handlers.delete(method);
    }
  }

  stop() {
    this.connection.stop();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/signal-r.service.ts